
import React, { useEffect, useState } from 'react'
import { Button, Space } from 'antd';
import { URL_BACKEND } from '../../api/url';
import { useNavigate } from "react-router-dom";
import { sortDirections } from '../../data/datos';

export const useAspirantes = () => {

    const navegar = useNavigate()
    const [data, setData] = useState([])
    const [textoBuscar, setTextoBuscar] = useState("")
    const [datosAspirantes, setDatosAspirantes] = useState([])
    const [ciclosExamen, setCiclosExamen] = useState([])
    const [ciclo, setCiclo] = useState('todos')

    const [loading, setLoading] = useState( true )

    // funciones
    const traerAspirantes = () => {

        let datos = new FormData()
        datos.append('funcion', 'traerAspirantes');
        datos.append('ciclo', ciclo);

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( function( d ){

            setDatosAspirantes( d )
            setData( d )

        })
        .finally(() => setLoading( false ))
    }

    const filtrar = ( cosaABuscar ) => {

        cosaABuscar = cosaABuscar.trim()

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = data.filter( function( elemento ){

                let busqueda = new RegExp( cosaABuscar, 'gi' )
                if ( busqueda.test( elemento.nombre )
                    || busqueda.test( elemento.apellido_p )
                    || busqueda.test( elemento.apellido_m )
                    || busqueda.test( elemento.prematricula )
                    || busqueda.test( elemento.correo ) ) {
                    return true
                } else {
                    return false
                }

            })
            setDatosAspirantes( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setDatosAspirantes( data )
        }
    }

    const traerCiclosExamen = () => {

        let datos = new FormData()
        datos.append('funcion', 'traerCiclosExamen');

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( setCiclosExamen )
    }


    // useEffects
    useEffect(() => {
        traerAspirantes()
        traerCiclosExamen()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {

        filtrar( textoBuscar )
        // eslint-disable-next-line
    }, [ textoBuscar ])

    useEffect(() => {
        traerAspirantes()
        // eslint-disable-next-line
    }, [ ciclo ])

    // algo del buscador
    // pinche antDesign tas raro we


    // las columnas de la tabla
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            sortDirections
        },
        {
            title: 'Apellido paterno',
            dataIndex: 'apellido_p',
            sortDirections
        },
        {
            title: 'Apellido materno',
            dataIndex: 'apellido_m',
            sortDirections
        },
        {
            title: 'Prematrícula',
            dataIndex: 'prematricula',
            sortDirections
        },
        {
            title: 'Carrera',
            dataIndex: 'nom_carrera',
        },
        {
            title: 'Correo',
            dataIndex: 'correo',
            sortDirections
        },
        {
          title: 'Acciones',
          render: (text, record) => (
            <Space size="middle">
              <Button type='link' onClick={ ()=> navegar(`/aspirantes/editar/${record.pk_aspirante}`) }>
                Editar
              </Button>
            </Space>
          ),
        },
    ];


    return {
        columns,
        datosAspirantes,
        loading,
        textoBuscar,
        setTextoBuscar,
        ciclo, setCiclo, ciclosExamen
    }

}
